import React, { useState } from "react";
import "./addAccessControlModal.css";

const humanize = (str = "") => str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const AddAccessControlModal = ({ open, missingSections, onCancel, onAdd }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);

  if (!open) return null;

  const toggleKey = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleAdd = () => {
    if (selectedKeys.length === 0) return;
    const sectionsToAdd = missingSections.filter((s) => selectedKeys.includes(s.key));
    onAdd(sectionsToAdd);
    setSelectedKeys([]);
  };

  const handleCancel = () => {
    setSelectedKeys([]);
    onCancel();
  };

  return (
    <div className="aam-overlay" onClick={handleCancel}>
      <div className="aam-modal" onClick={(e) => e.stopPropagation()}>
        <div className="aam-header">
          <h3>Add access control</h3>
          <button type="button" className="aam-close" onClick={handleCancel} aria-label="Close">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {missingSections.length === 0 ? (
          <p className="aam-empty">All sidebar sections already have access control set up for this manager.</p>
        ) : (
          <div className="aam-list">
            {missingSections.map((section) => (
              <label className="aam-item" key={section.key}>
                <input
                  type="checkbox"
                  checked={selectedKeys.includes(section.key)}
                  onChange={() => toggleKey(section.key)}
                />
                <span className="aam-item-icon">
                  {section.icon ? <img src={section.icon} alt="" /> : humanize(section.name).slice(0, 2)}
                </span>
                <span className="aam-item-name">{section.name}</span>
              </label>
            ))}
          </div>
        )}

        <div className="aam-footer">
          <button type="button" className="aam-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="aam-btn aam-btn--primary"
            onClick={handleAdd}
            disabled={selectedKeys.length === 0}
          >
            Add ({selectedKeys.length})
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAccessControlModal;